import { AppThunk } from 'store';
import { batch } from 'react-redux';
import { userAPI } from 'entities/user';
import setAuthData from 'common/utils/auth/setAuthData';
import { USER_TYPES } from 'common/utils/userTypes';
import parseAuthData from 'common/utils/auth/parseAuthData';
import resetAuthData from 'common/utils/auth/resetAuthData';
import { getResponseError } from 'common/utils/index';
import addGTMEvent from 'common/utils/addGTMEvent';
import { getContourBURL } from 'entities/application';
import { isIOS, isSafariBrowser } from 'common/utils/checkBrowserType';

import config from 'config';

import EVENT_TYPES_GTM from 'common/constants/eventTypesGTM';
import { STATUS_LOADING } from 'common/constants/statusLoading';
import { IS_DIFFERENT_CONTOURS } from 'entities/application';
import { CROSS_ORIGIN_MESSAGE_TYPES } from 'entities/user';

import slice from '../reducer/slice';
import { applicationActions } from 'entities/application';
import { checkIsUserCountourB } from 'entities/user';
import { createHiddenIFrame, checkIsIFrameLoaded } from 'shared/utils';

import { intl } from 'i18n';

const { setUserType, setUser, setUserLoadingStatus } = slice.actions;
const { setErrorNotice } = applicationActions;

type TOperation = (identifyToken: string, clientId?: string) => AppThunk;

const operation: TOperation = (identifyToken, clientId) => async (dispatch) => {
  try {
    dispatch(setUserLoadingStatus(STATUS_LOADING.load));

    const { data: { data } } = await userAPI.getAuthTokensByIdentityToken(identifyToken, clientId);

    const authData = parseAuthData(data);

    if (IS_DIFFERENT_CONTOURS && !isIOS && !isSafariBrowser && checkIsUserCountourB(authData.contourType)) {
      const contourBIframe = createHiddenIFrame(config.contourB);
      await checkIsIFrameLoaded(contourBIframe);
      contourBIframe.contentWindow?.postMessage({
        type: CROSS_ORIGIN_MESSAGE_TYPES.token,
        data: data.refresh_token
      }, config.contourB);
      setTimeout(() => {
        window.location.replace(getContourBURL());
      }, 1000);
    } else {
      setAuthData(authData);
      addGTMEvent(EVENT_TYPES_GTM.login, { userId: authData.clientCode, userType: authData.userType });
      batch(() => {
        dispatch(setUserLoadingStatus(STATUS_LOADING.done));
        dispatch(setUser(authData));
        dispatch(setUserType(USER_TYPES.autorized));
      });
    }

    return authData;
  } catch (e) {
    const { title, code } = await getResponseError(e);
    batch(() => {
      dispatch(setErrorNotice({
        title: intl.formatMessage(
          { id: `error.${code}` },
          { userName: clientId }
        ) || title
      }));
      resetAuthData();
      dispatch(setUserLoadingStatus(STATUS_LOADING.error));
      dispatch(setUserType(USER_TYPES.unautorized));
    });
  }
};

export default operation;